import { defineStore } from 'pinia';

const getDefaultState = () => ({
  notifications: [],
  unreadCount: 0,
});

export const useNotificationsStore = defineStore('notifications', {
  state: getDefaultState,
  persist: true,
  actions: {
    setNotifications(notifications) {
      this.notifications = notifications;
    },
    setUnReadNotifications(unreadNotifications) {
      this.unreadCount = unreadNotifications
    },
    addNotification(notification) {
      this.notifications.push(notification); // Añadir una nueva notificación al array
      this.unreadCount++; // Incrementa el contador de notificaciones no leídas
    },
    markAllAsRead() {
      this.notifications.forEach((notif) => {
        notif.read = true; // Marca todas las notificaciones como leídas
      });
      this.unreadCount = 0; // Resetea el contador de no leídas
    },
    markAsRead(notificationId) {
      const notification = this.notifications.find(notif => notif.id === notificationId);
      if (notification) {
        notification.read = true; // Marca la notificación específica como leída
        this.unreadCount--; // Decrementa el contador de no leídas
      }
    },
  },
  getters: {
    getNotifications: (state) => state.notifications,
    getUnreadCount: (state) => state.unreadCount,
  }
});
